import { render, staticRenderFns } from "./AuthProfile.vue?vue&type=template&id=ad54c21c&scoped=true"
import script from "./AuthProfile.vue?vue&type=script&lang=js"
export * from "./AuthProfile.vue?vue&type=script&lang=js"
import style0 from "./AuthProfile.vue?vue&type=style&index=0&id=ad54c21c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad54c21c",
  null
  
)

export default component.exports